import { showModal } from "./modal";

const langSwitcherSelector = ".lang-switcher";
const openLangSwitcherSelector = ".lang-switcher[open]";
const langSwitcherTriggerSelector = ".lang-switcher-trigger";
// const langFormSelector = ".locale-selectors__content form";
const switchLanguageModalId = "catifa-propose-language-switch";
const storageKey = "langSwitchInteracted";

const switchLocale = (langCode: string) => {
  // https://shopify.dev/docs/storefronts/themes/markets/localization-discovery
  const langMarket = langCode.toLocaleLowerCase();
  const formId = crypto.randomUUID();
  const currentPath = window.location.pathname + window.location.search;

  const formHtml = `
    <form id="${formId}" action="/localization" method="POST" hidden>
      <input name="_method" value="PUT">
      <input name="country_code" value="${langMarket}">
      <input name="language_code" value="${langMarket}">
      <input type="hidden" name="return_to" value="${currentPath}">
    </form>
  `;
  document.body.insertAdjacentHTML("beforeend", formHtml);
  (document.getElementById(formId) as HTMLFormElement)?.submit();
};

export const manageLangSwitcher = () => {
  // each time the user visits the store but has not selected his language, propose him to switch
  const currentLangIsoCode = document
    .querySelector<HTMLElement>("[data-country-current=true]")
    ?.dataset?.code?.toLowerCase();

  const userLanguageIsoCode =
    navigator.language.toLowerCase().split("-")[0]?.toLowerCase() ?? "en";

  if (currentLangIsoCode) {
    if (!userLanguageIsoCode.startsWith(currentLangIsoCode)) {
      // open lang modal to propose user to switch to "correct" language
      const switchProposal = document.getElementById("switch-proposal");
      const locales = switchProposal?.dataset?.locales?.replace(/=>/g, ":");
      if (switchProposal && locales) {
        const parsedLocales = JSON.parse(locales);
        const proposedLangIsCode = Object.keys(parsedLocales).includes(
          userLanguageIsoCode,
        )
          ? userLanguageIsoCode
          : "en";
        switchProposal.innerText = switchProposal.innerText.replace(
          "{{ language }}",
          parsedLocales[proposedLangIsCode],
        );
      }

      document
        .querySelector("#switch-to-proposed-language")
        ?.addEventListener("click", (e) => {
          e.preventDefault();
          localStorage.setItem(storageKey, "true");
          switchLocale(userLanguageIsoCode);
        });

      const hasTheUserInteracted = localStorage.getItem(storageKey);
      if (!hasTheUserInteracted) {
        showModal(switchLanguageModalId, () => {
          localStorage.setItem(storageKey, "true");
        });
      }
    }
  }

  window.addEventListener("click", (ev) => {
    const trigger = document.querySelector<HTMLElement>(
      langSwitcherTriggerSelector,
    );
    if (document.querySelector(openLangSwitcherSelector) == null) {
      return;
    }
    if (ev.target != trigger && !trigger?.contains(ev.target as Node)) {
      trigger?.click();
      localStorage.setItem(storageKey, "true");
    }
  });

  document
    .querySelector(langSwitcherSelector)
    ?.querySelectorAll<HTMLLIElement>("[data-code]")
    ?.forEach((langSwitcherItem) => {
      langSwitcherItem.addEventListener("click", (e) => {
        e.preventDefault();
        const langCode = langSwitcherItem.dataset.code;
        if (!langCode) {
          return;
        }
        localStorage.setItem(storageKey, "true");
        switchLocale(langCode);
      });
    });
};
